import Daily_actions_controller from '../daily_actions_controller'

export default class extends Daily_actions_controller {
  static targets = [
    'overallInput',
    'overallInputCustom',
    'overallInputCustomAnswer',
    'overallInputAnswer',
    'overallInputError',
    'recoveryInput',
    'recoveryInputCustom',
    'recoveryInputCustomAnswer',
    'recoveryInputAnswer',
    'recoveryInputError',
    'medicationName',
    'medicationDosage',
    'medicationFrequency',
    'medicationReminder',
    'medicationsListError',
    'unsavedMedicationsError',
    'medicationInput',
    'medicationInputCustom',
    'medicationInputCustomAnswer',
    'medicationInputAnswer',
    'displayOverallQuestions',
    'displayRecoveryQuestions',
    'displayMedicationQuestions',
    'displayQuestionCard',
    'medication',
    'medicationTable',
    'medicationTableRow',
    'medicationTableBody',
    'checkbox',
    'answerField',
    'phoneNumberError'
  ]

  initialize(){
    this.autofillMedications()

    // Wait for auto-save controller to restore form data before checking answer fields
    setTimeout(() => {
      this.toggleAnswerField()
    }, 100)
  }

  displayInputs () {
    const questionCard =
      this.displayQuestionCardTarget.content.querySelector('div')
    this.displayOverallQuestionsTarget.innerHTML = ''
    this.displayRecoveryQuestionsTarget.innerHTML = ''
    this.displayMedicationQuestionsTarget.innerHTML = ''
    this.medicationTableBodyTarget.innerHTML = ''

    let overallInputsPresent = false
    this.overallInputTargets.forEach((checkbox) => {
      if (checkbox.checked) {
        overallInputsPresent = true
        // creates new card with values
        const newCard = questionCard.cloneNode(true)
        const questionText = checkbox.labels[0].querySelector('.flex.flex-row').innerText
        
        // Find the corresponding answer input for this checkbox
        const answerInput = checkbox.closest('div').querySelector('textarea[data-daily-actions--1-target="overallInputAnswer"]')

        if (answerInput && answerInput.value.length > 0) {
          newCard.innerHTML = `${questionText}<br><br><span class="text-very-dark-gray font-normal">${answerInput.value}</span>`
        } else {
          newCard.innerHTML = questionText
        }

        // appends it to step 4 location
        this.displayOverallQuestionsTarget.appendChild(newCard)
      }
    })

    this.overallInputCustomTargets.forEach((input, index) => {
      if (input.value.length === 0) return

      overallInputsPresent = true
      const newCard = questionCard.cloneNode(true)
      
      // Find the corresponding custom answer input for this custom question
      const customAnswerInput = document.querySelectorAll('textarea[data-daily-actions--1-target="overallInputCustomAnswer"]')[index]
      
      if (customAnswerInput && customAnswerInput.value.length > 0) {
        newCard.innerHTML = `${input.value}<br><br><span class="text-very-dark-gray font-normal">${customAnswerInput.value}</span>`
      } else {
        newCard.innerHTML = input.value
      }

      // appends it to step 4 location
      this.displayOverallQuestionsTarget.appendChild(newCard)
    })

    if (overallInputsPresent === true) {
      this.displayOverallQuestionsTarget.parentElement.style.display = 'block'
    } else {
      this.displayOverallQuestionsTarget.parentElement.style.display = 'none'
    }

    let recoveryInputsPresent = false
    this.recoveryInputTargets.forEach((checkbox) => {
      if (checkbox.checked) {
        recoveryInputsPresent = true

        // creates new card with values
        const newCard = questionCard.cloneNode(true)
        const questionText = checkbox.labels[0].querySelector('.flex.flex-row').innerText
        
        // Find the corresponding answer input for this checkbox
        const answerInput = checkbox.closest('div').querySelector('textarea[data-daily-actions--1-target="recoveryInputAnswer"]')

        if (answerInput && answerInput.value.length > 0) {
          newCard.innerHTML = `${questionText}<br><br><span class="text-very-dark-gray font-normal">${answerInput.value}</span>`
        } else {
          newCard.innerHTML = questionText
        }

        // appends it to step 4 location
        this.displayRecoveryQuestionsTarget.appendChild(newCard)
      }
    })

    this.recoveryInputCustomTargets.forEach((input, index) => {
      if (input.value.length === 0) return
      recoveryInputsPresent = true

      const newCard = questionCard.cloneNode(true)
      
      // Find the corresponding custom answer input for this custom question
      const customAnswerInput = document.querySelectorAll('textarea[data-daily-actions--1-target="recoveryInputCustomAnswer"]')[index]
      
      if (customAnswerInput && customAnswerInput.value.length > 0) {
        newCard.innerHTML = `${input.value}<br><br><span class="text-very-dark-gray font-normal">${customAnswerInput.value}</span>`
      } else {
        newCard.innerHTML = input.value
      }

      // appends it to step 4 location
      this.displayRecoveryQuestionsTarget.appendChild(newCard)
    })

    if (recoveryInputsPresent === true) {
      this.displayRecoveryQuestionsTarget.parentElement.style.display = 'block'
    } else {
      this.displayRecoveryQuestionsTarget.parentElement.style.display = 'none'
    }

    // Medication Section
    let medicationInputsPresent = false
    let medicationsPresent = false

    this.medicationInputTargets.forEach((checkbox) => {
      if (checkbox.checked) {
        medicationInputsPresent = true

        // creates new card with values
        const newCard = questionCard.cloneNode(true)
        const questionText = checkbox.labels[0].querySelector('.flex.flex-row').innerText
        
        // Find the corresponding answer input for this checkbox
        const answerInput = checkbox.closest('div').querySelector('textarea[data-daily-actions--1-target="medicationInputAnswer"]')

        if (answerInput && answerInput.value.length > 0) {
          newCard.innerHTML = `${questionText}<br><br><span class="text-very-dark-gray font-normal">${answerInput.value}</span>`
        } else {
          newCard.innerHTML = questionText
        }

        // appends it to step 4 location
        this.displayMedicationQuestionsTarget.appendChild(newCard)
      }
    })

    this.medicationInputCustomTargets.forEach((input, index) => {
      if (input.value.length === 0) return
      medicationInputsPresent = true

      const newCard = questionCard.cloneNode(true)
      
      // Find the corresponding custom answer input for this custom question
      const customAnswerInput = document.querySelectorAll('textarea[data-daily-actions--1-target="medicationInputCustomAnswer"]')[index]
      
      if (customAnswerInput && customAnswerInput.value.length > 0) {
        newCard.innerHTML = `${input.value}<br><br><span class="text-very-dark-gray font-normal">${customAnswerInput.value}</span>`
      } else {
        newCard.innerHTML = input.value
      }

      // appends it to step 4 location
      this.displayMedicationQuestionsTarget.appendChild(newCard)
    })

    this.medicationTargets.forEach((med) => {
      let valuesPresent = true
      const displayText = []
      med.querySelectorAll('input, select').forEach((input) => {
        if (input.value.length === 0) {valuesPresent = false}

        let value = input.value
        if (input.classList.contains('frequency-field')) {
          value = input.querySelector(`option[value="${input.value}"]`).textContent
        }

        displayText.push(value)
      })

      if (valuesPresent === false) return

      medicationsPresent = true
      medicationInputsPresent = true

      const newRow = this.medicationTableRowTarget.cloneNode(true)

      let i = 0
      newRow.querySelectorAll('td').forEach((col) => {
        col.innerHTML = displayText[i]
        i++
      })

      this.medicationTableBodyTarget.appendChild(newRow)
    })

    if (medicationInputsPresent === true) {
      this.displayMedicationQuestionsTarget.parentElement.style.display =
        'block'
    } else {
      this.displayMedicationQuestionsTarget.parentElement.style.display =
        'none'
    }

    if (medicationsPresent === true) {
      const medicationTable = this.medicationTableTarget.cloneNode(true)
      medicationTable.style.display = 'block'
      this.displayMedicationQuestionsTarget.prepend(medicationTable)
    } else {
      this.medicationTableTarget.style.display = 'none'
    }
  }

  checkInput (event) {
    const targetName = event.currentTarget.dataset.target
    let filled = false

    const errorTarget = this[`${targetName}ErrorTarget`]

    const defaultInputs = this[`${targetName}Targets`].filter(
      (target) => target.checked == true
    )
    const customInputs = this[`${targetName}CustomTargets`].filter(
      (target) => target.value.length > 0
    )

    if (defaultInputs.length > 0 || customInputs.length > 0) {
      filled = true
    }

    if (!filled) {
      this.throwError(event, errorTarget)
    } else {
      errorTarget.style.display = 'none'
    }
  }

  checkMedications (event) {
    const nameCount = this.medicationNameTargets.filter(
      (el) => el.value != ''
    ).length
    const doseCount = this.medicationDosageTargets.filter(
      (el) => el.value != ''
    ).length
    const freqCount = this.medicationFrequencyTargets.filter(
      (el) => el.value != ''
    ).length

    const filledReminderTimeFields = this.medicationReminderTargets.filter(el => el.value == '').length == 0
    let inputsValid = nameCount == doseCount && doseCount == freqCount

    if (event.currentTarget.dataset.singleMedication == 'true' && (!nameCount || !doseCount || !freqCount)) {
      inputsValid = false
    }

    if (filledReminderTimeFields && inputsValid) {
      this.hideError(this.medicationsListErrorTarget)
    } else {
      event.preventDefault()
      this.throwError(event, this.medicationsListErrorTarget, 'center')
    }

    if (!this.hasUnsavedMedicationsErrorTarget) { return }
    if (document.getElementsByClassName('medication-save-button').length > 0) {
      event.preventDefault()
      this.throwError(event, this.unsavedMedicationsErrorTarget, 'center')
    } else {
      this.hideError(this.unsavedMedicationsErrorTarget)
    }
  }

  checkPhoneNumber(event) {
    // If verify number field is hidden, skip error check
    if (document.getElementById('verify-number-field')?.classList.contains('hidden') || document.getElementById('verify-number-section')?.classList.contains('hidden')) { 
      return 
    }

    let verified = document.getElementById('phone-settings').dataset.verifiedTarget == "verified"

    if (verified) {
      this.hideError(this.phoneNumberErrorTarget)
    } else {
      this.throwError(event, this.phoneNumberErrorTarget, 'center')
    }

  }

  hideError (target) {
    target.style.display = 'none'
  }

  throwError (event, target, position) {
    event.stopImmediatePropagation()
    target.style.display = 'block'
    target.scrollIntoView({ behavior: 'smooth', block: position })
  }

  autofillMedications () {
    const localStorageKey = `autosave:${gon.user_id}:${window.location.pathname}`;

    if (localStorage.getItem(localStorageKey) == null){ return };

    const data = JSON.parse(localStorage.getItem(localStorageKey));
    let rows = Math.max(
      0, // Default value if no valid indices are found
      ...Object.keys(data)
          .map(key => key.match(/^medication\[(\d+)\]/)) // Match "medication[N]"
          .filter(match => match) // Remove nulls
          .map(match => Number(match[1])) // Extract and convert to number
    ) + 1;
    
    for (let i = 0; i < rows; i++) {
      if (i == 0) {
        let target = document.getElementById('medication-inputs')
        this.copyMedicationData(target, data, 0)
        this.updateMedicationOptions(null, document.querySelector('select[name="medication[0][frequency]"]'))
      } else {
        let new_row = document.getElementById('medication-input-template').content.cloneNode(true)
        this.copyMedicationData(new_row, data, i)
        this.updateMedicationOptions(null, new_row.querySelector('select[name="medication[][frequency]"]'))
        document.getElementById('medication-inputs').appendChild(new_row)
      }
    }

    this.updateMedicationInputNames()
  }

  copyMedicationData(target, data, i) {
    let inputIndex = i == 0 ? '[0]' : '[]'
    target.querySelector(`input[name="medication${inputIndex}[name]"]`).value = data[`medication[${i}][name]`]
    target.querySelector(`input[name="medication${inputIndex}[dosage]"]`).value = data[`medication[${i}][dosage]`]
    target.querySelector(`select[name="medication${inputIndex}[frequency]"]`).value = data[`medication[${i}][frequency]`]
  }

  updateMedicationOptions (event, target) {
    this.medicationsListErrorTarget.style.display = 'none'
    let medicationInput = event ? event.currentTarget : target
    let frequencyValue = medicationInput.value
    let reminderFieldsTarget = medicationInput.closest('.medication_fields').querySelector('.reminder_fields')
    reminderFieldsTarget.innerHTML = ''
    let templateIdSuffix = medicationInput.dataset.templateIdSuffix
    let reminderTemplate = templateIdSuffix ? document.querySelector(`#reminder-${frequencyValue}${templateIdSuffix}`) : document.querySelector(`#reminder-${frequencyValue}`)

    if (frequencyValue == '' || !reminderTemplate) { 
      this.updateMedicationInputNames()
      return 
    }

    let reminderFields = reminderTemplate.content.cloneNode(true)
    reminderFieldsTarget.appendChild(reminderFields)
    this.updateMedicationInputNames()
  }

  updateMedicationInputNames () {
    if (!document.querySelector('#medication-inputs')) { return }
    let i = 0
    document.querySelector('#medication-inputs').querySelectorAll('.medication_reminder_target').forEach(el => {
      let input = el.querySelector('input')

      if (input) {
        let inputLabel = el.querySelector('label')
        input.id = `${input.id}_${i}`
        inputLabel.setAttribute('for', input.id)
      }
      i++
    })

    i = 0

    document.querySelector('#medication-inputs').querySelectorAll('.medication_fields').forEach(el => {
      el.querySelectorAll('input[name*="medication["], select[name*="medication["]').forEach(input => {
        input.name = input.name.replace(/medication\[\d*\]/, `medication[${i}]`)
      })
      i++
    })
  }

  showVerifyNumberField(event) {
    if (document.getElementById('verify-number-field')) {
      if (event.currentTarget.checked) {
        document.getElementById('verify-number-field').classList.add('hidden')
        this.phoneNumberErrorTarget.style.display = 'none'
        // enable submit button on hh dashboard
        if (document.getElementById('submit-medication-button')) {
          document.getElementById('submit-medication-button').disabled = false
          document.getElementById('submit-medication-button').classList.remove('bg-disable')
          document.getElementById('submit-medication-button').classList.add('bg-violet', 'cursor-pointer')
        }
      } else {
        document.getElementById('verify-number-field').classList.remove('hidden')
        if (document.getElementById('submit-medication-button')) {
          // disable submit button on hh dashboard
          document.getElementById('submit-medication-button').disabled = true
          document.getElementById('submit-medication-button').classList.add('bg-disable')
          document.getElementById('submit-medication-button').classList.remove('bg-violet', 'cursor-pointer')
        }
      }
      
    }
  }

  toggleAnswerField(event) {
    const checkboxes = event ? [event.currentTarget] : this.checkboxTargets

    checkboxes.forEach((checkbox) => {
      const answerField = checkbox.closest('div').querySelector('[data-daily-actions--1-target="answerField"]')

      if (checkbox.checked) {
        // Slide down animation
        answerField.classList.remove('slide-up')
        answerField.classList.add('slide-down')
      } else {
        // Slide up animation
        answerField.classList.remove('slide-down')
        answerField.classList.add('slide-up')

        // Clear the answer field when unchecked
        const input = answerField.querySelector('textarea')

        if (input) {
          input.value = ''
        }
      }
    })
  }
}
